import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a944c80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-5 mt-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "" }, "Manage Users")
  ])
], -1))
const _hoisted_3 = { class: "nav toolbar my-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus fa-fw" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add User ")
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "table table-striped" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "First Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Name Prefix"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"200px"} }, "Role"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"150px"} }, "Actions")
  ])
], -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "role-name px-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-check" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-xmark" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-pen-to-square" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-trash" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "text-center"
}
const _hoisted_31 = {
  key: 0,
  class: "modal show fade",
  tabindex: "-1"
}
const _hoisted_32 = { class: "modal-dialog" }
const _hoisted_33 = { class: "modal-content" }
const _hoisted_34 = { class: "modal-header" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Delete user", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to delete this user?")
], -1))
const _hoisted_37 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: { name: 'add-users' },
        class: "btn btn-primary"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.usersLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      _createElementVNode("td", null, [
                        (user.id === _ctx.updateUserId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "new-user-firstName",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updatedUserFirstName) = $event)),
                                placeholder: "Enter new first name"
                              }, null, 512), [
                                [_vModelText, _ctx.updatedUserFirstName]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(user.firstName), 1))
                      ]),
                      _createElementVNode("td", null, [
                        (user.id === _ctx.updateUserId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "new-user-lastName",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updatedUserLastName) = $event)),
                                placeholder: "Enter new last name"
                              }, null, 512), [
                                [_vModelText, _ctx.updatedUserLastName]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(user.lastName), 1))
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, _toDisplayString(user.email), 1)
                      ]),
                      _createElementVNode("td", null, [
                        (user.id === _ctx.updateUserId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "new-user-lastNamePrefix",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.updatedUserLastNamePrefix) = $event)),
                                placeholder: "Enter new last name prefix"
                              }, null, 512), [
                                [_vModelText, _ctx.updatedUserLastNamePrefix]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(user.lastNamePrefix), 1))
                      ]),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.roles, (role, idx) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "badge rounded-pill me-3 d-inline-flex flex-row align-items-center",
                            key: idx,
                            style: {"min-height":"35px","background-color":"var(--raffish-green)","color":"var(--bs-black)"}
                          }, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(role.name), 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("td", null, [
                        (user.id === _ctx.updateUserId)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                type: "button",
                                onClick: ($event: any) => (_ctx.confirmUpdateUser(user.id))
                              }, _hoisted_20, 8, _hoisted_18),
                              _createElementVNode("button", {
                                class: "btn btn-secondary ms-3",
                                type: "button",
                                onClick: ($event: any) => (_ctx.cancelUpdateUser(user.id))
                              }, _hoisted_23, 8, _hoisted_21)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("button", {
                                class: "btn btn-outline-primary",
                                type: "button",
                                onClick: ($event: any) => {
                                                _ctx.startUpdateUser(
                                                    user.id,
                                                    user.firstName,
                                                    user.lastName,
                                                    user.lastNamePrefix,
                                                );
                                                _ctx.updateUserEmail = user.email;
                                            }
                              }, _hoisted_26, 8, _hoisted_24),
                              _createElementVNode("button", {
                                class: "btn btn-outline-danger ms-3",
                                type: "button",
                                onClick: ($event: any) => (_ctx.startDeleteUser(user.id))
                              }, _hoisted_29, 8, _hoisted_27)
                            ], 64))
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, "Loading users..."))
      ])
    ]),
    (_ctx.deleteUserId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteUser && _ctx.cancelDeleteUser(...args)))
                })
              ]),
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteUser && _ctx.cancelDeleteUser(...args)))
                }, "Close"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteUser && _ctx.confirmDeleteUser(...args)))
                }, "Delete user")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}